/*
 * @Author:
 * @Date: 2023-12-14 13:32:45
 * @LastEditors: Merlin
 * @LastEditTime: 2025-08-05 13:42:37
 * @Description: 全局
 */

import { defineStore } from 'pinia';

interface Screen {
    min: number;
    max: number;
}

interface GlobalStore {
    loginDialogIsOpen: boolean;
    pageLoaded: boolean;
    innerWidth: number;
    client: boolean;
    markForReload: number,
    redpacketReload: number,
    screens: {
        sm: Screen;
        md: Screen;
        lg: Screen;
        xl: Screen;
        gmd: { min: number };
    };
    jackpotSum: {
        "dice": number,
        "plinko": number,
        "crash": number,
        "circle": number,
        "hilo": number,
        "spacedice": number // 1.294870090634819
    },
    chipsConfig: object;
    specialValue: any; // 用于前后端跨环境调试
    wsConnection: boolean;
}

const useGlobalStore = defineStore('global', {
    state: (): GlobalStore => {
        const { theme } = useRuntimeConfig().public.tailwind;
        const isClient = import.meta.client;
        const oState = {
            loginDialogIsOpen: false, // 控制登录注册窗口的可见性
            innerWidth: isClient ? window.innerHeight : 0, // 当前浏览器宽度 window.innerWidth（包含右侧滚动条）
            client: false, // 默认为 false 页面加载后会被赋值 true（触发某些属性弃用服务端生成的值，在客户端重新取）
            // ↑ 因为一些值只能在前端取得时，这样写： globalStore.client && yourValue， 这样可使你的值在前端生效，否则你的值会后端取到错的值，推到浏览器后也不能更正
            // ↑ 或 globalStore.client ? yourValue : 默认值
            screens: theme.extend.screensInt,
            markForReload: 0, // 用于刷新页面 
            redpacketReload: 0, // 用于刷新红包页面 
            pageLoaded: false, // 将在刷新页面后被赋值为 true，特定动作只在引值为 true 之后执行
            jackpotSum: {
                "dice": 0,
                "plinko": 0,
                "crash": 0,
                "circle": 0,
                "hilo": 0,
                "spacedice": 0 // 1.294870090634819
            },
            chipsConfig: {}, // 筹码配置 
            specialValue: '',
            wsConnection: true, // 默认 ws 已经连接 true，断线后会赋值为 false 
        };
        return oState;
    },
    actions: {
        setState(partialState: object) {
            Object.assign(this, partialState);
        },
        setClientMark() {
            this.client = true;
            // console.log("this.client 赋值", this.client);
        },
        setInnerWidth() {
            // console.log("窗口尺寸", window.innerWidth);
            this.innerWidth = window.innerWidth;
        },
    },
    getters: {
        screenMode(oState){
            const {screens, innerWidth} = oState;
            if (innerWidth >= screens.xl.min) return 'xl';
            if (innerWidth >= screens.lg.min) return 'lg';
            if (innerWidth >= screens.md.min) return 'md';
            return 'sm';
        },
        // ↓ 一些游戏的在自动模式下注按钮文字会在不同的屏幕宽度下显示不同的内容
        // Crash, Roulette, Mines, Keno, Pharoh 
        autoModeBtnWords(oState){
            const isMobile = oState.innerWidth <= 550;
            const i18nKey = {
                start: isMobile ? 'BetStart' : 'game.startAutoBet',
                stop: isMobile ? 'BetStop' : 'game.stopAutoBet',
            };
            return i18nKey;
        },
    },
});

export default useGlobalStore;
